import React from "react";
import { WorkplaceAssessmentComponentProps } from './WorkplaceAssessmentComponentProps';
import { ActionPlansPanelListing } from "./ActionPlansPanelListing";
import ActionPlanView from '../../../pages/actionplans/components/ActionPlanView';


export function ActionPlansPanel(props:WorkplaceAssessmentComponentProps): JSX.Element {

    const [loaded, setLoaded] = React.useState(false);
    const [selectedId, setSelectedId] = React.useState('');

    React.useEffect(function(){
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const id = urlParams.get('actionPlanId');
        if(id)
            setSelectedId(id);
        setLoaded(true)
    }, [window.location.search]);

    function handleClickActionPlan(actionPlanId:string)
    {
        window.history.replaceState(null, '', `/workplaceassessments/${props.activity.id}?tab=actionplans&actionPlanId=${actionPlanId}`);
        setSelectedId(actionPlanId);
    }

    function handleClickBack()
    {
        window.history.replaceState(null, '', `/workplaceassessments/${props.activity.id}?tab=actionplans`);
        setSelectedId('');
    }
    
    return (
        <>
            {loaded && selectedId === '' &&
                <ActionPlansPanelListing {...props} onActionPlanSelected={handleClickActionPlan} />
            }

            {loaded && selectedId !== '' &&
                <ActionPlanView actionPlanId={selectedId} onBack={handleClickBack}
                    backLink={{ text: 'Tilbage til oversigten', url: `/workplaceassessments/${props.activity.id}?tab=actionplans` }} />
            }

        </>
    );
}